function formatCurrency(value) {
  const c = new Intl.NumberFormat("de-DE").format(value)
  return c
}

export default formatCurrency
